import api from '@/lib/axiosConfig';
import rollbarClient from '@/lib/rollbar/rollbarClient';

import type Rollbar from 'rollbar';

/**
 * Fetch period data for a given group
 * Separate from fetchData because it doesn't use the required lang param
 */
export async function fetchPeriodData(groupId: string) {
  const url = '/rest_api/period_filter/';
  try {
    const response = await api.get(url, { withCredentials: true, params: { group: groupId } });
    return response.data;
  } catch (error) {
    rollbarClient.error('Error fetching period data', error as Rollbar.LogArgument, { url });
  }
}
